/**
 * Question helpers for the crossword stage (old/crosswordnew.php).
 * Each theme row under `questions_and_answers` is one crossword word with a
 * text, image or video clue (see functions/crosswordQuestions.js); the crossword
 * layout algorithm places every answer into a shared grid.
 */

import { getUsableCrosswordQuestions } from "../../functions/crosswordQuestions";

/** All usable questions configured on the theme (normalized, any clue type). */
export function getCrosswordPairs(themeData) {
  return getUsableCrosswordQuestions(themeData?.questions_and_answers);
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
